import { render, staticRenderFns } from "./MoveSpinner2.vue?vue&type=template&id=36061f55&scoped=true&"
import script from "./MoveSpinner2.vue?vue&type=script&lang=js&"
export * from "./MoveSpinner2.vue?vue&type=script&lang=js&"
import style0 from "./MoveSpinner2.vue?vue&type=style&index=0&id=36061f55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36061f55",
  null
  
)

export default component.exports